import client from './api-client';

export const getConfiguracionForm21 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form21: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getConfiguracionForm22 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form22: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosAntecendetesJudiciales = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado/antec-judiciales?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosAntecedentesJudiciales: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboCompetencia = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboCompetencia: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboCorte = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboCorte: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboTribunales = async(query) => {
    try {
        
        const response = await client.get(`tribunales?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboTribunales: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboLibros = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboLibros: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboHitoJudicial = async(query) => {
    try {
        
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboHitoJudicial: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getGrillaHistorialJudicial = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado/contacto/hitos?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                grillaHistorialJudicial: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const actualizarProcesoJudicial = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/antec-judiciales', file);
      
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaJudicial: response.data};
        } else {
            return {respuestaJudicial: response.data};
        }
        
    } catch(error){
        throw error;
    }
}
export const actualizarTipoGastos = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/provison-gastos', file);
        
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaTipoGastos: response.data};
        } else {
            return {respuestaTipoGastos: response.data};
        }
        
    } catch(error){
        throw error;
    }
}
export const postAnular = async(file) => {
    try {
        
        const response = await client.post('getion-implicado/provison-gastos', file);
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaAnular: response.data};
        } else {
            return {respuestaAnular: response.data};
        }
        
    } catch(error){
        throw error;
    }
}
export const getComboTipoGasto = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboTipoGasto: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboCobertura = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboCobertura: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboMonedas = async(query) => {
    try {
        
        const response = await client.get(`monedas?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboMonedas: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getGrillaHistorialGastos = async(query) => {
    try {
        
        const response = await client.get(`getion-implicado/provison-gastos/historial?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                grillaHistorialGastos: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const verDocumento = async(query) => {
    try {
        const response = await client.verDocumento(`get-file?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}